/* LK GALERIE SWIPE - carrousel scroll-snap natif (mobile) + tap-zoom.
   Best practice DTC 2026: scroll-snap natif iOS, aucune lib JS de drag.
   Construit dynamiquement depuis .lp9-thumb (data-full). Aucune modif du markup section.
   Desktop: track masque en CSS, le swap d'image classique reste intact. Ajoute 2026-06-20.
   - image PLEINE LARGEUR + espace reduit (gap/padding) ; miniatures masquees mobile.
   - reorderBuybox(): place le PRIX juste avant les etoiles (prix plus haut/proeminent). */
(function () {
  var CSS = [
    '@media (max-width:767px){',
    '.lp9-grid{padding-top:.6rem !important;gap:1.25rem !important;}',
    '.lp9-media.lk-has-swipe{display:block;}',
    '.lp9-media.lk-has-swipe>#lp9MainImg{display:none;}',
    '.lp9-media-wrapper .lp9-thumbs{display:none !important;}',
    '.lk-swipe-track{display:flex;overflow-x:auto;scroll-snap-type:x mandatory;-webkit-overflow-scrolling:touch;scroll-behavior:smooth;scrollbar-width:none;border-radius:24px;}',
    '.lk-swipe-track::-webkit-scrollbar{display:none;}',
    '.lk-swipe-slide{flex:0 0 100%;scroll-snap-align:center;scroll-snap-stop:always;display:flex;justify-content:center;align-items:center;}',
    '.lk-swipe-slide img{width:100%;height:auto;max-width:640px;object-fit:contain;border-radius:24px;background:#fff;cursor:zoom-in;}',
    '.lk-swipe-dots{display:flex;gap:7px;justify-content:center;margin-top:10px;}',
    '.lk-swipe-dot{width:8px;height:8px;border-radius:50%;border:0;padding:0;background:rgba(0,0,0,.18);cursor:pointer;transition:background .2s ease,transform .2s ease;}',
    '.lk-swipe-dot.is-active{background:#d63384;transform:scale(1.3);}',
    '}',
    '@media (min-width:768px){.lk-swipe-track,.lk-swipe-dots{display:none !important;}}',
    '.lk-swipe-zoom{position:fixed;inset:0;background:rgba(15,10,20,.92);z-index:9999;display:flex;align-items:center;justify-content:center;padding:16px;cursor:zoom-out;}',
    '.lk-swipe-zoom[hidden]{display:none;}',
    '.lk-swipe-zoom img{max-width:100%;max-height:100%;object-fit:contain;border-radius:12px;}'
  ].join('');

  function withW(url, w) {
    if (!url) { return url; }
    return url.split('width=1024').join('width=' + w);
  }
  function srcset(url) {
    var ws = [320, 480, 640, 800, 1024];
    var out = [];
    for (var i = 0; i < ws.length; i++) { out.push(withW(url, ws[i]) + ' ' + ws[i] + 'w'); }
    return out.join(', ');
  }

  /* Place le prix (et le prix/unite) juste avant les etoiles -> titre > prix > etoiles. */
  function reorderBuybox() {
    var buy = document.querySelector('.lp9-buy');
    if (!buy || buy.getAttribute('data-lk-reordered') === '1') { return; }
    var price = buy.querySelector('.lp9-price');
    var stars = buy.querySelector('.lk-star-rating');
    if (!price || !stars) { return; }
    var ppu = buy.querySelector('.lp9-price-per-unit');
    buy.insertBefore(price, stars);
    if (ppu) { buy.insertBefore(ppu, stars); }
    buy.setAttribute('data-lk-reordered', '1');
  }

  function init() {
    var media = document.querySelector('.lp9-media');
    var wrapper = document.querySelector('.lp9-media-wrapper');
    if (!media || !wrapper) { return; }
    if (wrapper.getAttribute('data-lk-swipe') === '1') { return; }

    var thumbsWrap = document.querySelector('.lp9-thumbs');
    var thumbs = thumbsWrap ? Array.prototype.slice.call(thumbsWrap.querySelectorAll('.lp9-thumb')) : [];
    if (thumbs.length < 2) { return; }

    var sources = thumbs.map(function (t) {
      var im = t.querySelector('img');
      return { url: t.getAttribute('data-full'), alt: im ? im.getAttribute('alt') : '' };
    });

    wrapper.setAttribute('data-lk-swipe', '1');

    if (!document.getElementById('lk-swipe-style')) {
      var st = document.createElement('style');
      st.id = 'lk-swipe-style';
      st.textContent = CSS;
      document.head.appendChild(st);
    }

    var track = document.createElement('div');
    track.className = 'lk-swipe-track';
    track.id = 'lkSwipeTrack';
    track.setAttribute('role', 'list');
    track.setAttribute('aria-label', 'Galerie photos - glisse pour voir');

    sources.forEach(function (s, i) {
      var slide = document.createElement('div');
      slide.className = 'lk-swipe-slide';
      slide.setAttribute('role', 'listitem');
      slide.setAttribute('data-index', i);
      var img = document.createElement('img');
      img.src = s.url;
      if (s.url) { img.setAttribute('srcset', srcset(s.url)); }
      img.setAttribute('sizes', '(max-width:768px) 100vw, 50vw');
      img.alt = s.alt || '';
      img.loading = i === 0 ? 'eager' : 'lazy';
      img.decoding = 'async';
      img.width = 800;
      img.height = 800;
      slide.appendChild(img);
      track.appendChild(slide);
    });

    var dots = document.createElement('div');
    dots.className = 'lk-swipe-dots';
    sources.forEach(function (s, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'lk-swipe-dot' + (i === 0 ? ' is-active' : '');
      b.setAttribute('aria-label', 'Aller a la photo ' + (i + 1));
      b.setAttribute('data-index', i);
      dots.appendChild(b);
    });

    media.appendChild(track);
    if (thumbsWrap && thumbsWrap.parentNode === wrapper) { wrapper.insertBefore(dots, thumbsWrap); }
    else { wrapper.appendChild(dots); }
    media.classList.add('lk-has-swipe');

    var slides = track.querySelectorAll('.lk-swipe-slide');
    var dotEls = dots.querySelectorAll('.lk-swipe-dot');

    function setActive(i) {
      for (var d = 0; d < dotEls.length; d++) { dotEls[d].classList.toggle('is-active', d === i); }
      for (var t = 0; t < thumbs.length; t++) { thumbs[t].classList.toggle('is-active', t === i); }
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting && e.intersectionRatio >= 0.6) {
            setActive(parseInt(e.target.getAttribute('data-index'), 10));
          }
        });
      }, { root: track, threshold: [0.6] });
      for (var k = 0; k < slides.length; k++) { io.observe(slides[k]); }
    }

    function goTo(i) {
      if (slides[i]) { slides[i].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' }); }
    }

    var mqMobile = window.matchMedia('(max-width:767px)');
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function (e) {
        if (mqMobile.matches) { e.preventDefault(); e.stopImmediatePropagation(); goTo(i); }
      }, true);
    });
    dotEls.forEach(function (d, i) {
      d.addEventListener('click', function () { goTo(i); });
    });

    var zoom = document.getElementById('lkSwipeZoom');
    if (!zoom) {
      zoom = document.createElement('div');
      zoom.className = 'lk-swipe-zoom';
      zoom.id = 'lkSwipeZoom';
      zoom.setAttribute('hidden', '');
      var zi = document.createElement('img');
      zi.alt = '';
      zoom.appendChild(zi);
      document.body.appendChild(zoom);
      zoom.addEventListener('click', function () { zoom.setAttribute('hidden', ''); document.body.style.overflow = ''; });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { zoom.setAttribute('hidden', ''); document.body.style.overflow = ''; } });
    }
    var zImg = zoom.querySelector('img');
    for (var z = 0; z < slides.length; z++) {
      (function (sl) {
        var im = sl.querySelector('img');
        im.addEventListener('click', function () {
          zImg.src = withW(im.currentSrc || im.src, 1600);
          zImg.alt = im.alt || '';
          zoom.removeAttribute('hidden');
          document.body.style.overflow = 'hidden';
        });
      })(slides[z]);
    }
  }

  function runAll() { reorderBuybox(); init(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runAll);
  } else {
    runAll();
  }
  document.addEventListener('shopify:section:load', runAll);
})();
